/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SafeInputs */

const en_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safe`)
};

const es_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguro`)
};

const fr_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sécurisé`)
};

const de_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicher`)
};

const ja_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セーフ`)
};

const zh_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全区`)
};

const ar_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آمن`)
};

const id_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aman`)
};

const it_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicuro`)
};

const ru_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасная зона`)
};

const pt_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguro`)
};

const ko_safe = /** @type {(inputs: SafeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안전`)
};

/**
* | output |
* | --- |
* | "Safe" |
*
* @param {SafeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const safe = /** @type {((inputs?: SafeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SafeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_safe(inputs)
	if (locale === "es") return es_safe(inputs)
	if (locale === "fr") return fr_safe(inputs)
	if (locale === "de") return de_safe(inputs)
	if (locale === "ja") return ja_safe(inputs)
	if (locale === "zh") return zh_safe(inputs)
	if (locale === "ar") return ar_safe(inputs)
	if (locale === "id") return id_safe(inputs)
	if (locale === "it") return it_safe(inputs)
	if (locale === "ru") return ru_safe(inputs)
	if (locale === "pt") return pt_safe(inputs)
	return ko_safe(inputs)
});